export enum UserType {
    CORPORATE = 'CORPORATE',
    SUBSCRIPTION = 'SUBSCRIPTION',
}
